module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN208_590111725.5d7b7c29.png";